module.exports = "<div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <span class=q-boldest> {%- text %} </span> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/standardPlatformFacilitySetupWizard/html/rowTemplate.html
// module id = 307
// module chunks = 1